import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
@Component({
  selector: 'app-emponboarding-grid',
  templateUrl: './emponboarding-grid.component.html',
  styleUrls: ['./emponboarding-grid.component.scss']
})
export class EmponboardingGridComponent implements OnInit {

  constructor(public appservice:AppService,public router:Router) { }

  verifyemployee(data:any){
    this.appservice.onboardingeditid=data;
    this.router.navigate(['/home/emponboardingform'])
  }
  ngOnInit(): void {
    this.appservice.Employeeonbardinggrid();
  }

}
